export const AdsenseAccount = "ca-pub-9928387558540246";
